// Lib
import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Action, Dispatch } from 'redux';
import * as Immutable from 'immutable';

// Selectors
import { getModalState } from '../../../../../../components/modal/modalStateSelector';

// Actions
import { modalClosed } from '../../../../../../components/modal/modalActions';

// Components
import FullScreenModal from '../../../../../../components/modal/FullScreenModal';
import AiAssistantReportFeedbackModalContent from './AiAssistantReportFeedbackModalContent';

// Constants
import { ModalIds } from '../../../../../../components/modal/modalConstants';

// Types
import { AiLocalAiConversation, isIdeaDebugInfo } from '../state/aiToolStateTypes';
import { AiDebugInfo } from '../../../../../../../common/ai/aiConversationTypes';
import { ImMap } from '../../../../../../../common/utils/immutableHelper';

// Styles
import './AiAssistantReportFeedbackModal.scss';

interface ReportFeedbackModalProps {
    reportFeedbackModalState: Immutable.Map<string, ImMap<AiLocalAiConversation>>;
    dispatchModalClose: () => void;
}

const mapStateToProps = createStructuredSelector({
    reportFeedbackModalState: getModalState(ModalIds.AI_REPORT_FEEDBACK),
});

const mapDispatchToProps = (dispatch: Dispatch<Action>) => ({
    dispatchModalClose: () => dispatch(modalClosed(ModalIds.AI_REPORT_FEEDBACK)),
});

const AiAssistantReportFeedbackModal = (props: ReportFeedbackModalProps) => {
    const { reportFeedbackModalState, dispatchModalClose } = props;
    const currentConversation = reportFeedbackModalState?.get('currentConversation').toJS();

    const conversationId = currentConversation?._id;
    const title = currentConversation?.title;
    const results = currentConversation?.results;
    const currentResultDebugInfo: AiDebugInfo = results?.find(isIdeaDebugInfo) || {};

    return (
        <FullScreenModal
            modalName={ModalIds.AI_REPORT_FEEDBACK}
            className="AiAssistantReportFeedbackModal"
            {...props}
            overlay
            styled={true}
            close={dispatchModalClose}
        >
            <AiAssistantReportFeedbackModalContent
                conversationId={conversationId}
                title={title}
                debugInfo={currentResultDebugInfo}
                dispatchModalClose={dispatchModalClose}
            />
        </FullScreenModal>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(AiAssistantReportFeedbackModal);
